import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const rekappotonganPDF = (periode, data) => {
  if (!data || data.length === 0) {
    alert("Tidak ada data untuk dicetak.");
    return;
  }

  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();

  const tahun = periode.slice(0, 4);
  const bulanAngka = parseInt(periode.slice(4, 6));
  const namaBulan = new Date(tahun, bulanAngka - 1).toLocaleString("id-ID", { month: "long" });

  const loadImageAsDataURL = (url) => {
    return fetch(url)
      .then((res) => res.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );
  };

  const drawHeader = (logoDataUrl) => {
    const logoX = 10;
    const logoY = 8;
    const logoSize = 18;
    const textX = logoX + logoSize + 3;

    if (logoDataUrl) {
      doc.addImage(logoDataUrl, "PNG", logoX, logoY, logoSize, logoSize);
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text("KPRI SRI REJEKI", textX, 14);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text("Jl. Donomulyo No.164 Kab. Malang", textX, 19);

    const lineY = logoY + logoSize + 3;
    doc.setLineWidth(0.3);
    doc.line(8, lineY, pageWidth - 8, lineY);

    const reportY = lineY + 7;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text('Rekap Potongan KPRI "SRI REJEKI"', pageWidth / 2, reportY, { align: "center" });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(`Tagihan : ${namaBulan} ${tahun}`, pageWidth / 2, reportY + 6, { align: "center" });

    return reportY + 10;
  };

  const headers = [[
    { content: "No", styles: { halign: "center" } },
    { content: "Unit Kerja", styles: { halign: "left" } },
    { content: "Anggota", styles: { halign: "center" } },
    { content: "S.Pokok", styles: { halign: "right" } },
    { content: "S.Wajib", styles: { halign: "right" } },
    { content: "S.Hari Raya", styles: { halign: "right" } },
    { content: "Angsuran", styles: { halign: "right" } },
    { content: "Jasa", styles: { halign: "right" } },
    { content: "Germen", styles: { halign: "right" } },
    { content: "Total", styles: { halign: "right" } }
  ]];

  const formatNumber = (num) => {
    return num === null || num === undefined || isNaN(num) ? "-" : parseFloat(num).toLocaleString("id-ID");
  };

  const calcTotal = (item) => {
    return (
      (+item.spokok || 0) +
      (+item.swajib || 0) +
      (+item.shariraya || 0) +
      (+item.smanasuka || 0) +
      (+item.angs_d || 0) + (+item.angs_c || 0) + (+item.angs_a || 0) +
      (+item.jasa_d || 0) + (+item.jasa_c || 0) + (+item.jasa_a || 0) +
      (+item.germen_d || 0) + (+item.germen_c || 0) + (+item.germen_a || 0) +
      (+item.svoucher || 0)
    );
  };

  let totalAnggota = 0, totalSpokok = 0, totalSwajib = 0, totalShariraya = 0;
  let totalAngsuran = 0, totalJasa = 0, totalGermen = 0, totalKeseluruhan = 0;

  const tableData = data.map((item, index) => {
    const spokok = parseFloat(item.spokok) || 0;
    const swajib = parseFloat(item.swajib) || 0;
    const shariraya = parseFloat(item.shariraya) || 0;
    const angsuran = (parseFloat(item.angs_d) || 0) + (parseFloat(item.angs_c) || 0) + (parseFloat(item.angs_a) || 0);
    const jasa = (parseFloat(item.jasa_d) || 0) + (parseFloat(item.jasa_c) || 0) + (parseFloat(item.jasa_a) || 0);
    const germen = (parseFloat(item.germen_d) || 0) + (parseFloat(item.germen_c) || 0) + (parseFloat(item.germen_a) || 0);
    const total = spokok + swajib + shariraya + angsuran + jasa + germen;

    totalAnggota += parseFloat(item.anggota) || 0;
    totalSpokok += spokok;
    totalSwajib += swajib;
    totalShariraya += shariraya;
    totalAngsuran += angsuran;
    totalJasa += jasa;
    totalGermen += germen;
    totalKeseluruhan += total;

    return [
      { content: index + 1, styles: { halign: "right" } },
      { content: item.unit_kerja || "-", styles: { halign: "left" } },
      { content: formatNumber(item.anggota), styles: { halign: "center" } },
      { content: formatNumber(spokok), styles: { halign: "right" } },
      { content: formatNumber(swajib), styles: { halign: "right" } },
      { content: formatNumber(shariraya), styles: { halign: "right" } },
      { content: formatNumber(angsuran), styles: { halign: "right" } },
      { content: formatNumber(jasa), styles: { halign: "right" } },
      { content: formatNumber(germen), styles: { halign: "right" } },
      { content: formatNumber(total), styles: { halign: "right" } }
    ];
  });

  tableData.push([
    { content: "Total Keseluruhan", colSpan: 2, styles: { fontStyle: "bold", halign: "center", fillColor: [230, 230, 230] } },
    { content: formatNumber(totalAnggota), styles: { fontStyle: "bold", halign: "center", fillColor: [230, 230, 230] } },
    { content: formatNumber(totalSpokok), styles: { fontStyle: "bold", halign: "right", fillColor: [230, 230, 230] } },
    { content: formatNumber(totalSwajib), styles: { fontStyle: "bold", halign: "right", fillColor: [230, 230, 230] } },
    { content: formatNumber(totalShariraya), styles: { fontStyle: "bold", halign: "right", fillColor: [230, 230, 230] } },
    { content: formatNumber(totalAngsuran), styles: { fontStyle: "bold", halign: "right", fillColor: [230, 230, 230] } },
    { content: formatNumber(totalJasa), styles: { fontStyle: "bold", halign: "right", fillColor: [230, 230, 230] } },
    { content: formatNumber(totalGermen), styles: { fontStyle: "bold", halign: "right", fillColor: [230, 230, 230] } },
    { content: formatNumber(totalKeseluruhan), styles: { fontStyle: "bold", halign: "right", fillColor: [230, 230, 230] } }
  ]);

  const renderTable = (startY) => {
  const tableWidth = 277; // Lebar tabel A4 landscape
  const marginLeft = (pageWidth - tableWidth) / 2;

  autoTable(doc, {
    head: headers,
    body: tableData,
    startY: startY,

    theme: "grid",

    // TABEL BENAR-BENAR DI TENGAH
    tableWidth: tableWidth,

    margin: {
      left: marginLeft,
      right: marginLeft,
      top: 10,
      bottom: 10,
    },

    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      overflow: "linebreak",
      valign: "middle",
    },

    headStyles: {
      halign: "center",
      valign: "middle",
      fontSize: 8,
      cellPadding: 2,
      fillColor: [0, 191, 165],
      textColor: 255,
      fontStyle: "bold",
    },

    bodyStyles: {
      fontSize: 8,
      valign: "middle",
    },

    showHead: "everyPage",

    // TOTAL = 277 mm
    columnStyles: {
      0: {
        cellWidth: 10,
        halign: "center",
      },

      1: {
        cellWidth: 55,
        halign: "left",
      },

      2: {
        cellWidth: 20,
        halign: "center",
      },

      3: {
        cellWidth: 28,
        halign: "right",
      },

      4: {
        cellWidth: 28,
        halign: "right",
      },

      5: {
        cellWidth: 28,
        halign: "right",
      },

      6: {
        cellWidth: 28,
        halign: "right",
      },

      7: {
        cellWidth: 25,
        halign: "right",
      },

      8: {
        cellWidth: 25,
        halign: "right",
      },

      9: {
        cellWidth: 30,
        halign: "right",
      },
    },

    didDrawPage: () => {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);

      doc.text(
        `Page ${doc.internal.getNumberOfPages()}`,
        pageWidth / 2,
        doc.internal.pageSize.height - 5,
        {
          align: "center",
        }
      );
    },
  });

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);

  window.open(pdfUrl, "_blank");
};
  const customLogoUrl = "/koperasihitamputih.png";

  loadImageAsDataURL(customLogoUrl)
    .then((logoDataUrl) => {
      const startY = drawHeader(logoDataUrl);
      renderTable(startY);
    })
    .catch((err) => {
      console.warn("Logo tidak ditemukan:", err);
      const startY = drawHeader();
      renderTable(startY);
    });
};

export default rekappotonganPDF;
